import { IIconProps } from '../interface';

const SvgCaymanIslands = ({ width = 56, height = 56 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56 28C56 43.4639 43.4639 56 28 56C12.5361 56 0 43.4639 0 28C0 28.0067 28 0.0030625 28 0C43.4639 0 56 12.5361 56 28Z"
      fill="#0052B4"
    />
    <path
      d="M27.925 28H28C28 27.9748 28 27.9503 28 27.9251C27.975 27.9501 27.9501 27.9751 27.925 28Z"
      fill="#F0F0F0"
    />
    <path
      d="M28 14.6087C28 9.68188 28 6.45367 28 0H27.9953C12.5334 0.002625 0 12.5375 0 28H14.6087V19.7738L22.8349 28H27.9252C27.9501 27.9751 27.9751 27.9501 28.0001 27.9251C28.0001 26.0387 28.0001 24.3555 28.0001 22.8351L19.7737 14.6087H28Z"
      fill="#F0F0F0"
    />
    <path
      d="M40.1739 20.6957C42.8633 20.6957 45.0435 18.5155 45.0435 15.8261C45.0435 13.1367 42.8633 10.9565 40.1739 10.9565C37.4845 10.9565 35.3043 13.1367 35.3043 15.8261C35.3043 18.5155 37.4845 20.6957 40.1739 20.6957Z"
      fill="#6DA544"
    />
    <path
      d="M14.1657 3.65214C9.7864 6.14578 6.14563 9.78644 3.6521 14.1657V28H10.9565V10.9567V10.9565H28C28 8.65276 28 6.45804 28 3.65214H14.1657Z"
      fill="#D80027"
    />
    <path
      d="M28 24.5568L18.0518 14.6088H14.6086V14.609L27.9998 28H28C28 28 28 25.6258 28 24.5568Z"
      fill="#D80027"
    />
    <path
      d="M31.6521 14.6087H48.6956V21.9131H31.6521V14.6087Z"
      fill="#D80027"
    />
    <path
      d="M31.6521 32.8696V37.7392H34.2141C35.7503 39.2446 37.853 40.174 40.1738 40.174C42.4947 40.174 44.5974 39.2446 46.1336 37.7392H46.2608H48.6956V32.8696H31.6521Z"
      fill="#FFDA44"
    />
    <path
      d="M31.6521 20.6956V28C31.6521 34.523 40.1738 36.5217 40.1738 36.5217C40.1738 36.5217 48.6956 34.523 48.6956 28V20.6956H31.6521Z"
      fill="#338AF3"
    />
    <path
      d="M40.1734 24.5972C38.0431 24.5972 38.0431 26.5451 35.9128 26.5451C33.7825 26.5451 33.7825 24.5972 31.6522 24.5972V28.0059C33.7825 28.0059 33.7825 29.9538 35.9128 29.9538C38.0431 29.9538 38.0431 28.0059 40.1734 28.0059C42.3039 28.0059 42.3039 29.9538 44.4345 29.9538C46.5652 29.9538 46.5651 28.0059 48.6957 28.0059V24.5972C46.5652 24.5972 46.5652 26.5451 44.4345 26.5451C42.3039 26.5451 42.3039 24.5972 40.1734 24.5972Z"
      fill="#F3F3F3"
    />
    <path
      d="M40.1734 17.7739C38.0431 17.7739 38.0431 19.7217 35.9128 19.7217C33.7825 19.7217 33.7825 17.7739 31.6522 17.7739V21.1825C33.7825 21.1825 33.7825 23.1304 35.9128 23.1304C38.0431 23.1304 38.0431 21.1825 40.1734 21.1825C42.3039 21.1825 42.3039 23.1304 44.4345 23.1304C46.5652 23.1304 46.5651 21.1825 48.6957 21.1825V17.7739C46.5652 17.7739 46.5652 19.7217 44.4345 19.7217C42.3039 19.7217 42.3039 17.7739 40.1734 17.7739Z"
      fill="#F3F3F3"
    />
  </svg>
);

export default SvgCaymanIslands;
